import React, { useState } from "react";
import { Icon } from "antd";
import DeleteWidgetModal from "./DeleteWidgetModal";
import WidgetUninstall from "./WidgetUninstall";
import { IProps as IWidgetCardProps } from "./WidgetCard";
import { ReactComponent as EditIcon } from "../../../assets/svg/editIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svg/delete.svg";
import { ReactComponent as PreviewIcon } from "../../../assets/svg/eye_icon.svg";
import './styles/widget-card-tooltip.scss';
import { useHistory } from "react-router-dom";

interface IProps extends IWidgetCardProps {
  setTooltipVisible: (visibility: boolean) => void;
  install: boolean;
  deleteproduct: (id: string) => void;
  handleWidgetStatus: (widgetId: string, status: boolean) => void;
  editAccess:any;
}

const WidgetCardTooltip: React.FC<IProps> = ({ widget, setTooltipVisible, deleteproduct, install, handleWidgetStatus,editAccess }) => {
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const history = useHistory();

  const handleDeleteWidget = () => {
    setTooltipVisible(false);
    setDeleteModalVisible(true);
  };
  const handleUnInstall = () => {
    setTooltipVisible(false);
    setDeleteModalVisible(true);
  };

  const handleClick = (): void => {
    history.push(`/marketplace/widgets/widgetPreview/${widget.id}`)
  }

  const handleEdit = (): void => {
    history.push(`/marketplace/widgets/edit/${widget.id}`)
  }
  
  const WIDTH = "16px";
  const HEIGHT = "16px";

  return (
    <div className="widget-card-tooltip">
      <div data-test-id="eye_icon" className="option" onClick={handleClick}>
        <PreviewIcon style={{ marginTop: "5px" }}/>
        <span style={{ color: "#292d32" }} >Preview</span>
      </div> 
      {editAccess ?
        <div className="option" onClick={handleEdit}>
          <EditIcon data-test-id="edit_icon" width={WIDTH} height={HEIGHT} />
          <span style={{ color: "#292d32" }} >Edit</span>
        </div> : null}

      {install ?
        <>
          <div className="option" onClick={handleUnInstall}>
            <DeleteIcon data-test-id="delete_icon" width={WIDTH} height={HEIGHT} />
            <span style={{ color: "#292d32" }} >UnInstall</span>
          </div>
          <WidgetUninstall
            visible={deleteModalVisible}
            setVisible={setDeleteModalVisible}
            handleWidgetStatus={handleWidgetStatus}
            widget={widget}
          />
        </>
        :
        <>
          {editAccess ?
            <div>
              <div className="option" onClick={handleDeleteWidget}>
                <DeleteIcon width={WIDTH} height={HEIGHT} />
                <span style={{ color: "#292d32" }} >Delete</span>
              </div><DeleteWidgetModal
                data-test-id="delete_widget_modal"
                visible={deleteModalVisible}
                setVisible={setDeleteModalVisible}
                {...widget}
                deleteproduct={deleteproduct} />
            </div>
            : null}
        </>
      }
    </div>
  );
};

export default WidgetCardTooltip;
